import { render, staticRenderFns } from "./PopularMovie.vue?vue&type=template&id=02bf1bed&"
import script from "./PopularMovie.vue?vue&type=script&lang=js&"
export * from "./PopularMovie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports